import React from 'react';
import PerformanceGapCard from './PerformanceGapCard';
import TrendingDownIcon from '@mui/icons-material/TrendingDown';

interface StaffMember {
  Name?: string;
  Area?: string;
  Reason?: string;
}

interface PerformanceGapsSectionProps {
  staff: (StaffMember | string)[];
}

const PerformanceGapsSection: React.FC<PerformanceGapsSectionProps> = ({ staff }) => {
  return (
    <div style={{
      background: '#fff',
      borderRadius: '12px',
      padding: '2rem',
      //marginBottom: '1.5rem',
      boxShadow: '0 4px 12px rgba(0,0,0,0.08)',
      borderLeft: '4px solid #805ad5',
      breakInside: 'avoid'
    }}>
      <h2 style={{ color: '#805ad5', marginBottom: '1rem', fontSize: '1.5rem', fontWeight: '600', display: 'flex', alignItems: 'center' }}>
        <TrendingDownIcon style={{ marginRight: '8px' }} />
        Performance Gaps
      </h2>
      <ul style={{ listStyle: 'none', padding: 0 }}>
        {staff?.map((staffMember, index) => (
          <PerformanceGapCard key={index} staff={staffMember} />
        ))}
      </ul>
    </div>
  );
};

export default PerformanceGapsSection;
